import "./Search.css";
import React, { useState, useEffect } from "react";
import { db } from "../../index";
import { ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";

const LoadingIndicator = () => (
  <div className="loading-indicator">
    <p>Загрузка...</p>
  </div>
);

const EmptyRequestsMessage = () => (
  <div className="empty-requests-message">
    <p>Данные не найдены <img src="./img/document-error.svg" alt="NotFoundData" /></p>
  </div>
);

const OpenedRequestRow = ({ request, handleOpenForm, dispatchersNames }) => (
  <div key={request.id} onClick={() => handleOpenForm(request.id)} className="items-table__search items-table__">
    <div className="width_item">
      <h2>{request.nameObject}</h2>
      <p>{request.address}</p>
    </div>
    <div className="width_item">
      <p>{request.description}</p>
    </div>
    <div>
      <div>
        <h3>{request.idRequest? "Завершена" : "Открыта"}</h3>
        <div className="items-table__search-state">
          <img src="./img/engineer-dark.svg" alt="engineer"/>
          <div className="search-state_personal">
          <p>{request.engineer || "Не выбран"}</p>
          </div>
        </div>
        <div className="items-table__search-state">
          <img src="./img/dispatcher-dark.svg" alt="dispatcher"/>
          <div className="search-state_personal">
            <p>{dispatchersNames[request.dispatcherID] || request.dispatcher}</p>
          </div>
        </div>
      </div>
    </div>
    <div className="items-search-cell-last">
      <div className="dates">
        <h3>Ремонт</h3>
        <p>{request.date}</p>
      </div>
      <div className="dates">
        <h3>Создана</h3>
        <p>{request.createdDate}</p>
      </div>
      <div className="img-priority">
        <img src={request.selectedImage} alt="priority"/>
      </div>
    </div>
  </div>
);

export function Search() {
  const [search, setOpenedRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [engineerQuery, setEngineerQuery] = useState("");
  const [statusQuery, setStatusQuery] = useState("Открыта");
  const [dispatchersNames, setDispatchersNames] = useState({});
  const [engineers, setEngineers] = useState([]);
  const [dateQuery, setDateQuery] = useState("");
  
  useEffect(() => {
    const requestsRef = ref(db, "request");
    onValue(requestsRef, (snapshot) => {
      const search = [];
      const engineers = {};
      snapshot.forEach((childSnapshot) => {
        search.push({
          id: childSnapshot.key,
         ...childSnapshot.val(),
          idRequest: childSnapshot.val().idRequest
        });
        if (childSnapshot.val().engineer) {
          engineers[childSnapshot.val().engineer] = true;
        }
      });
      search.sort((a, b) => {
        if (a.selectedImage === "./img/high-priority.svg" && b.selectedImage!== "./img/high-priority.svg") {
          return -1;
        } else if (a.selectedImage!== "./img/high-priority.svg" && b.selectedImage === "./img/high-priority.svg") {
          return 1;
        } else {
          return 0;
        }
      });
      setOpenedRequests(search);
      setEngineers(Object.keys(engineers));
      setLoading(false);
    });
  }, []);

  const [allEngineers, setAllEngineers] = useState([]);

  useEffect(() => {
    const engineersRef = ref(db, "users");
    onValue(engineersRef, (snapshot) => {
      const allEngineers = [];
      snapshot.forEach((childSnapshot) => {
        if (childSnapshot.val().role === "Инженер") {
          allEngineers.push(childSnapshot.val().displayName);
        }
      });
      setAllEngineers(allEngineers);
    });
  }, []);

  useEffect(() => {
    const dispatchersRef = ref(db, "users");
    onValue(dispatchersRef, (snapshot) => {
      const dispatchersNames = {};
      snapshot.forEach((childSnapshot) => {
        dispatchersNames[childSnapshot.key] = childSnapshot.val().displayName;
      });
      setDispatchersNames(dispatchersNames);
    });
  }, []);


  const handleDateQueryChange = (e) => {
    setDateQuery(e.target.value);
  };
  const handleSearchQueryChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const handleEngineerQueryChange = (e) => {
    setEngineerQuery(e.target.value);
  };

  const handleStatusQueryChange = (e) => {
    setStatusQuery(e.target.value);
  };

  const handleOpenForm = (searchRequestID) => {
    navigate(`/search/${searchRequestID}`);
  };

  return (
  <div className="table__opened">
    <h1>Поиск</h1>
    <div className="items-table__search items-table__search-subtitle">
      <input
        className="field-input"
        type="text"
        placeholder="Название или адрес"
        value={searchQuery}
        onChange={handleSearchQueryChange}
      />
    </div>
    <div className="items-table__search items-table__search-title">
      <select className="field-input" value={engineerQuery} onChange={handleEngineerQueryChange}>
        <option value="">Все инженеры</option>
        {allEngineers.map((engineer) => (
          <option key={engineer} value={engineer}>{engineer}</option>
        ))}
      </select>
      <select className="field-input" value={statusQuery} onChange={handleStatusQueryChange}>
        <option value="Открыта">Открыта</option>
        <option value="Закрыта">Закрыта</option>
      </select>
      <input
        className="field-input"
        type="date"
        name="date"
        placeholder="Дата ремонта"
        value={dateQuery}
        onChange={handleDateQueryChange}
      />
    </div>
    <div className="items-table__search media-search">
      <span>Объект</span>
      <span>Проблема</span>
      <span>Состояние</span>
      <span>Даты</span>
    </div>
    {loading? (
      <LoadingIndicator />
    ) : search.length === 0? (
      <EmptyRequestsMessage />
    ) : (
      search
      .filter((request) => {
          const nameMatch = request.nameObject.toLowerCase().includes(searchQuery) || request.address.toLowerCase().includes(searchQuery);
          const engineerMatch = request.engineer.toLowerCase().includes(engineerQuery.toLowerCase());
          const statusMatch = statusQuery === "" || request.idRequest? statusQuery === "Закрыта" : statusQuery === "Открыта";
          const dateMatch = dateQuery === "" || request.date.includes(dateQuery);
          return nameMatch && engineerMatch && statusMatch && dateMatch;
        })
      .map((request) => (
          <OpenedRequestRow key={request.id} request={request} handleOpenForm={handleOpenForm} dispatchersNames={dispatchersNames} />
        ))
      .length === 0? (
          <div className="empty-requests-message">
            <p>Заявки не найдены по заданным критериям</p>
          </div>
        ) : (
          search
          .filter((request) => {
              const nameMatch = request.nameObject.toLowerCase().includes(searchQuery) || request.address.toLowerCase().includes(searchQuery);
              const engineerMatch = request.engineer.toLowerCase().includes(engineerQuery.toLowerCase());
              const statusMatch = statusQuery === "" || request.idRequest? statusQuery === "Закрыта" : statusQuery === "Открыта";
              const dateMatch = dateQuery === "" || request.date.includes(dateQuery);
              return nameMatch && engineerMatch && statusMatch && dateMatch;
            })
          .map((request) => (
              <OpenedRequestRow key={request.id} request={request} handleOpenForm={handleOpenForm} dispatchersNames={dispatchersNames} />
            ))
        )
    )}
  </div>
  );
}